import $ from './jquery-shim.js';
import 'owl.carousel';
import OwlCss from "owl.carousel/dist/assets/owl.carousel.css";
import OwlThemeCss from "owl.carousel/dist/assets/owl.theme.default.css";

var defaultOptions = {
  selector: '.owl-carousel',
};

export default class OwlCarousel {
  /**
   * 初期化
   * @param options
   */
  constructor(options) {
    this.options = $.extend(defaultOptions, options);
    this.init();
  }

  /**
   * 初期化
   */
  init() {

    // ターゲットを取得する
    this.targetAll = $(this.options.selector);


    // ターゲットが存在しない場合は実行しない
    if (!this.targetAll.length) {
      return false;
    }

    // 実行する
    this.run();
  }

  /**
   * 実行する
   */


  run() {

    // const gsap = this.options.gsap;

    //->スライダー
    this.targetAll.imagesLoaded(function () {


      $('.c-main-visual__slider').owlCarousel({
        items: 1,
        margin: 0,
        dots: true,
        loop: true,
        nav: false,
        onInitialized: function () {
          // gsap.animate
        },
        autoplayHoverPause: true,
        autoplay: true,
        autoplaySpeed: 500,
        smartSpeed: 600,
        autoWidth: false,
        autoHeight: false,
        center: true,
        animateOut: "fadeOut",
      });

    });


    //->カード_カルーセル
    this.targetAll.imagesLoaded(function () {


      if ($('.js-pickup-slider.owl-carousel').length <= 0) {
        return;
      }

      if ($('.js-pickup-slide').length <= 2) {
        $('.js-pickup-slider').removeClass("owl-carousel");
        $(".js-pickup-option").addClass("is-hidden");
        return;
      }

      const slidesNum = $('.js-pickup-slide').length;

      $("span.is-total-num").text(slidesNum);

      var pickupOwl = $('.js-pickup-slider').owlCarousel({
        margin: 21,
        dots: false,
        loop: true,
        nav: false,
        autoplayHoverPause: true,
        autoplay: true,
        autoplaySpeed: 500,
        autoWidth: false,
        autoHeight: false,
        center: false,
        smartSpeed: 300,
        responsive: {
          // breakpoint from 0 up
          0: {
            items: 7,
            center: true
          },
          // breakpoint from 750 up
          950: {
            items: 7,
          }
        }
      });

      $('.c-block-top-pickup__slider-btn.is-next').click(function () {
        pickupOwl.trigger('next.owl.carousel', [300]);
      })
// Go to the previous item
      $('.c-block-top-pickup__slider-btn.is-prev').click(function () {
        // With optional speed parameter
        // Parameters has to be in square bracket '[]'
        pickupOwl.trigger('prev.owl.carousel', [300]);
      })

      pickupOwl.on('changed.owl.carousel', function (e) {
        if (e.item.index < 7) {
          $("span.is-current-num").text(slidesNum);
        } else if (e.item.index > slidesNum + 6) {
          $("span.is-current-num").text(1);
        } else {
          $("span.is-current-num").text(e.item.index - 6);
        }
      });

    });

    this.targetAll.imagesLoaded(function () {


      if ($('.js-elementary-slider.owl-carousel').length <= 0) {
        return;
      }

      if ($('.js-elementary-slide').length <= 1) {
        $('.js-elementary-slider').removeClass("owl-carousel");
        $(".js-pickup-option").addClass("is-hidden");
        return;
      }

      var pickupOwl = $('.js-elementary-slider').owlCarousel({
        margin: 0,
        items: 1,
        stagePadding: 255,
        dots: true,
        loop: true,
        nav: true,
        autoplayHoverPause: true,
        autoplay: true,
        autoplaySpeed: 1000,
        autoWidth: false,
        autoHeight: false,
        center: true,
        smartSpeed: 1000,
        navText: ['<span class="gallery-slider-prev"></span>', '<span class="gallery-slider-next"></span>'],

        responsive: {
          // breakpoint from 0 up
          0: {
            stagePadding: 60,
          },
          750: {
            stagePadding: 200,
          },
          // breakpoint from 750 up
          950: {
          },
          1500: {
            stagePadding: 350,
          },
          1700: {
            stagePadding: 450,
          }
        }
      });

      let dots = document.querySelector('.js-elementary-slider .owl-dots');
      let dotswidth = dots.offsetWidth + 60;
      $(".js-elementary-slider .owl-nav").width(dotswidth);

    });

  }
}




